export const RECORD_NUMBER_DIGITS = 6;

export const RECORD_NUMBER_MODULE_PREFIXES = {
  purchases: "MDC",
  services: "MSI",
  occurrences: "MOC",
  inspections: "MVT",
  machinery: "MAQ",
  externalServices: "MTS",
  stock: "MDE",
  financial: "MDF",
  employees: "MCB",
  animals: "MDP",
  birds: "MAV",
  veterinary: "VET",
  haras: "MHR",
  locations: "LOC",
};

export const RECORD_NUMBER_COST_CENTER_SUFFIXES = {
  Sede: "SD",
  Haras: "HR",
  "Pecuária": "PC",
  Avicultura: "AV",
  Galinheiro: "AV",
};

export const RECORD_NUMBER_LIVESTOCK_SUFFIXES = {
  Bovinos: "BOV",
  Equinos: "EQU",
  Caprinos: "CAP",
  Outros: "OUT",
};

export const RECORD_NUMBER_RULES = {
  purchases: { prefix: "MDC", suffixKind: "costCenter" },
  services: { prefix: "MSI", suffixKind: "costCenter" },
  occurrences: { prefix: "MOC", suffixKind: "costCenter" },
  inspections: { prefix: "MVT", suffixKind: "costCenter" },
  machinery: { prefix: "MAQ", suffixKind: null },
  externalServices: { prefix: "MTS", suffixKind: "costCenter" },
  stock: { prefix: "MDE", suffixKind: "costCenter" },
  financial: { prefix: "MDF", suffixKind: "costCenter" },
  employees: { prefix: "MCB", suffixKind: null },
  animals: { prefix: "MDP", suffixKind: "livestock" },
  birds: { prefix: "MAV", suffixKind: null },
  veterinary: { prefix: "VET", suffixKind: null },
  haras: { prefix: "MHR", suffixKind: null },
  locations: { prefix: "LOC", suffixKind: null },
};

export const RECORD_NUMBER_EXAMPLES = {
  purchases: "MDC-000001-SD",
  services: "MSI-000001-PC",
  occurrences: "MOC-000001-HR",
  inspections: "MVT-000001-AV",
  machinery: "MAQ-000001",
  externalServices: "MTS-000001-SD",
  stock: "MDE-000001-PC",
  financial: "MDF-000001-HR",
  employees: "MCB-000001",
  animals: "MDP-000001-BOV",
  birds: "MAV-000001",
  veterinary: "VET-000001",
  haras: "MHR-000001",
  locations: "LOC-000001",
};
